import Vue from 'vue' //引入Vue
import App from './App.vue'
import './plugins/element.js' // 引入element ui
import router from './router'  //引入router.js
import store from './vuex/store.js' //引入Vuex store

import "nprogress/nprogress.css"; // nprogress 进度条样式
import "./assets/css/index.css";  //引入css样式
import "./assets/scss/style.scss";  //引入scss通用样式
import './assets/fonts/iconfont.css'; //引入阿里图标

import VueUeditorWrap from 'vue-ueditor-wrap' //引入百度ueditor富文本编辑器
Vue.component('VueUeditorWrap',VueUeditorWrap)

Vue.config.productionTip = false //关闭vue的生产提示

import './plugins/filter.js' //全局过滤器
import './plugins/mixin.js' //全局混入mixin
import http from './http' //将axios创建的实例引入
import api from './api'
import tool from './utils/tool.js' //全局工具函数引入
 

Vue.prototype.$http = http  //将实例赋值给Vue实例的原型中，可以在任意页面通过this.$http()方法请求数据
Vue.prototype.$api = api
Vue.prototype.$tool = tool

//上传图片的处理从
// Vue.mixin({
//   computed: {

//   },
//   methods: {
//     getAuthHeaders() { //相当于是挂载到Vue实例上可以在每个页面调用
//       return {
//         Authorization: `Bearer ${localStorage.token || ''}`
//       }
//     }
//   }
// })

import inputDirectives from '@/directives/inputDirectives';

//注册所有指令
Object.keys(inputDirectives).forEach(key => {
  Vue.directive(key, inputDirectives[key]);
});



const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

console.log(vm);
